import { createContext, useContext, useState, useCallback } from 'react';
import { Language } from '../shared/constants/userConstants';

import constantTranslations from '../shared/constants/constants.lang.json';
import { makeEnumTranslator } from '../shared/util/langLib';
import { MarkdownText } from '../components/common/CommonComponents';

const { ENGLISH, SPANISH } = Language;

const validateLanguage = (lang) => (lang === SPANISH ? SPANISH : ENGLISH);

const LanguageContext = createContext();
const LOCAL_STORAGE_TOKEN_KEY = 'lang';

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguageInternal] = useState(
    validateLanguage(localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)),
  );

  const setCurrentLanguage = useCallback((language) => {
    const validatedLanguage = validateLanguage(language);
    setCurrentLanguageInternal(validatedLanguage);
    localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, validatedLanguage);
  }, []);

  const constantsTranslator = makeEnumTranslator(constantTranslations);

  return (
    <LanguageContext.Provider value={{ currentLanguage, setCurrentLanguage, constantsTranslator }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (...allTranslations) => {
  const { currentLanguage, setCurrentLanguage, constantsTranslator } = useContext(LanguageContext);

  const lang = (code) => {
    for (const translations of allTranslations) {
      if (code in translations) {
        return <MarkdownText>{translations[code][currentLanguage] ?? '???'}</MarkdownText>;
      }
    }
    throw new Error(`Missing translation for code: "${code}"`);
  };

  const langForEnum = (enumObj, key) => constantsTranslator.langFor(enumObj, key, currentLanguage);

  const optionsForEnum = (enumObj) => enumObj.ALL_ITEMS.map((value) => ({ value, label: langForEnum(enumObj, value) }));

  return { lang, langForEnum, optionsForEnum, currentLanguage, setCurrentLanguage };
};
